import theme from '../theme/index.js';
function remCalc(px) {
  let base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  let forcePortable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (forcePortable) {
    return px + "px";
  } else {
    return px / base + "rem";
  }
}
const WHITE_THEME = "white";
const RED_THEME = "red";
const getTheme = isAM => {
  return isAM ? RED_THEME : WHITE_THEME;
};
const getBgColor = theme$1 => {
  return theme$1 === "dark" ? theme.colours.darkslate : theme$1 === RED_THEME ? theme.colours.singtelred_d6 : theme.colours.white;
};
export { getBgColor, getTheme, remCalc };